// src/components/GenderChart.tsx
import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

export type GenderDataPoint = {
  label: string;
  male: number;
  female: number;
  others: number;
};

interface Props {
  data: GenderDataPoint[];
}

export default function BarChart({ data }: Props) {
  const labels = data.map((d) => d.label);
  const cfg = {
    labels,
    datasets: [
      {
        label: 'Male',
        data: data.map((d) => d.male),
        backgroundColor: '#297CF7',
        barThickness: 16,
      },
      {
        label: 'Female',
        data: data.map((d) => d.female),
        backgroundColor: '#FF2F95',
        barThickness: 16,
      },
      {
        label: 'Others',
        data: data.map((d) => d.others),
        backgroundColor: '#000000',
        barThickness: 16,
      },
    ],
  };

  return (
    <div className='w-full h-[270px]'>
      <Bar
        data={cfg}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            x: {
              grid: { display: false, offset: true },
              border: { display: true, width: 2, color: '#ccc' },
              // ticks: { padding: 8 },
            },
            y: {
              beginAtZero: true,
              grid: {
                display: true,
                offset: true,
                lineWidth: 1,
                color: '#0000000D',
                drawTicks: false,
              },
              border: { display: true, width: 2, color: '#ccc' },
              // ticks: { padding: 8 },
            },
          },
          plugins: { legend: { display: false } },
        }}
      />
    </div>
  );
}
